@if (notification !== undefined) {
  <div class="notification mb-2 rounded-box" tabindex="0" [ngClass]="notification.isRead ? 'read' : 'unread'">
    <div class="flex flex-col items-start px-4 py-2">
      <span class="flex w-full items-center">
        <div class="ml-2 flex w-full flex-col">
          <div class="flex items-center justify-between">
            <div>
              <span class="items-center">
                {{ notification.content?.primaryText }}
              </span>
            </div>
            <div class="h-12 shrink-0">
              @if (notification.isRead) {
                <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
                  aria-label="Mark as unread" daisyTooltip="Mark as unread"
                  (click)="onMarkNotificationsReadStatusesClick(notification, false, $event)">
                  <i class="fa-regular fa-circle"></i>
                </button>
              } @else {
                <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
                  aria-label="Mark as read" daisyTooltip="Mark as read"
                  (click)="onMarkNotificationsReadStatusesClick(notification, true, $event)">
                  <i class="fa-solid fa-circle"></i>
                </button>
              }
            </div>
          </div>
          <div class="my-1 flex justify-between">
            <a class="cursor-pointer font-bold uppercase text-daisy-primary"
              [routerLink]="notification.content?.secondaryUrl | routerLinkSafeUrl" (click)="onHyperLinkClick(notification, $event)"
              daisyTooltip="Navigate to Report"
              target="_blank" rel="noopener noreferrer">
              <i class="fa-solid fa-file"></i>
              {{ notification.content?.secondaryText }}</a>
            <span class="text-base-content/60">
              {{ notification.createdOn | timeAgo }}
            </span>
          </div>
        </div>
      </span>
    </div>
  </div>
}
